module.exports = __webpack_public_path__ + "img/parking_4.4cadb209.jpeg";